var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

//YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

// シーズン切り替え
const seasonChange = () => {
  const $switcher = $('.js-ChangeSeason');
  $switcher.children('.btn').click(function () {

    if($(this).hasClass('current')){
      return false;
    }

    const $this = $(this);
    const index = $('.js-ChangeSeason .btn').index(this);
    const $target = $('.js-ChangeSeason_Target');

    $target.each(function(){
      $(this).children('.element').fadeOut(10);
      $(this).children('.element').eq(index).delay(10).fadeIn(200);
      $('.js-ChangeSeason .btn').removeClass('current');
      $this.addClass('current');
    });
  });
};
seasonChange();

// コスチューム切り替え
const costumeChange = () => {
  let num = 0;
  const $switcher = $('.js-ChangeCostume');
  $switcher.click(function () {

    const cosutumeLength = $(this).siblings().length - 1;

    num+=1;
    if(num > cosutumeLength){
      num = 0;
    }

    $(this).parent().children('.costume').fadeOut(10);
    $(this).parent().children('.costume').eq(num).delay(10).fadeIn(100);

  });
};
costumeChange();

//初期処理
const characterInit = () => {
  // const url = $(location).attr('href');
  //
  // if (url.indexOf("?season=") == -1) {
  // }else {
  //   const url_sp = url.split("?season=");
  //   const param = url_sp[url_sp.length - 1];
  //   const $target = $('.btn.' + param);
  //
  //   if(!$target.hasClass('current')){
  //     $target.trigger('click');
  //     console.log($target);
  //   }
  // }
  //
  // var new_url = url.replace(/\?season.*$/,"");
  // history.replaceState(null,null,new_url);

  $('.character-Detail').animate({opacity: 1},200);
};
characterInit();


// WEBPACK FOOTER //
// ./src/assets/js/character/script.js